// GENERATED FROM 'messages.json' (via yarn run messages:generate)
// !! DO NOT CHANGE MANUALLY !!

import { defineMessages } from "react-intl";

export const messages = defineMessages({
    spectaclesVideoPreviewError: {
        id: "apps.submit.hooks.spectaclesVideoPreviewError",
        description: "Spectacles video preview error.",
        defaultMessage:
            'Spectacles Lenses require an image preview with a 3:4 aspect ratio. Please click "Change Lens Preview" to select a keyframe from your video or upload a new image.',
    },
    aiClipReplacementError: {
        id: "apps.submit.hooks.aiClipReplacementError",
        description: "Ai clip replacement error.",
        defaultMessage: "An AI Clip Lens can only be replaced by another AI Clip Lens.",
    },
    nonAiClipReplacementError: {
        id: "apps.submit.hooks.nonAiClipReplacementError",
        description: "Non ai clip replacement error.",
        defaultMessage: "A non-AI Clip Lens cannot be replaced by an AI Clip Lens.",
    },
    submissionFailed: {
        id: "apps.submit.hooks.submissionFailed",
        description: "Submission failed.",
        defaultMessage: "Unable to complete this submission. Please try again.",
    },
    communityDistributionDenied: {
        id: "apps.submit.hooks.communityDistributionDenied",
        description: "Community distribution denied.",
        defaultMessage:
            'You don’t have permission to publish Lenses from this organization’s folder to your profile. Use "Save as Draft" instead, or contact an admin of this organization for access.',
    },
});
